import "./AnimatedMarker.css";

const iconSize = 48;

export function AnimatedMarker() {
	return (
		<div className="animated-marker">
			<svg viewBox="0 0 100 100" width={iconSize} height={iconSize}>
				<defs>
					<radialGradient id="radarGradient" cx="50%" cy="50%" r="50%">
						<stop
							offset="0%"
							stopColor="var(--palette-green-70)"
							stopOpacity="0.6"
						/>
						<stop
							offset="100%"
							stopColor="var(--palette-green-70)"
							stopOpacity="0.1"
						/>
					</radialGradient>
				</defs>

				<circle className="radar-circle" cx="50" cy="50" r="40" />
				<circle className="radar-ping" cx="50" cy="50" r="5" />
				<line className="radar-sweep" x1="50" y1="50" x2="90" y2="50" />
			</svg>
		</div>
	);
}
